import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const FANDANKO_ROUTES: Routes = [
  { path: `kontakt_8.html`, redirectTo: `/kontakt-os` },
  { path: `levering_78.html`, redirectTo: `/spørgsmål-og-svar` },
  { path: `om-fandanko_79.html`, redirectTo: `$/artikler/om%20mad%20af%20kvalitet` },
  { path: `ean-betaling_113.html`, redirectTo: `/artikler/ean-betaling` },
  { path: `allergener_95.html`, redirectTo: `/spørgsmål-og-svar` },
  { path: `persondatapolitik_102.html`, redirectTo: `/persondatapolitik` },
  { path: `betingelser_3.html`, redirectTo: `/handelsbetingelser` },
  { path: `afhentning-af-emballage_116.html`, redirectTo: `/spørgsmål-og-svar` },
  { path: `persondatapolitik_102.html`, redirectTo: `/persondatapolitik` },
  { path: `om-fandanko_79.html`, redirectTo: `/artikler/om%20mad%20af%20kvalitet` },
  { path: `betingelser_3.html`, redirectTo: `/handelsbetingelser` },
  { path: `job_121.html`, redirectTo: `/artikler/job` },
  { path: `kontakt_8.html`, redirectTo: `/kontakt-os` },
  { path: `sandwich_50.html`, redirectTo: `${environment.urls.products}/sandwich` },
  { path: `brunch_49.html`, redirectTo: `${environment.urls.products}/Brunch` },
  { path: `ready2heat_52.html`, redirectTo: `${environment.urls.products}/varm_selv` },
  { path: `tapas2go_53.html`, redirectTo: `${environment.urls.products}/tapas` },
  { path: `luksus-tapas-_109.html`, redirectTo: `${environment.urls.products}/TEST` },
  { path: `alt-godt-fra-havet-tapas_105.html`, redirectTo: `${environment.urls.products}/tapas` },
  { path: `unika-oste-tapas_93.html`, redirectTo: `${environment.urls.products}/tapas` },
  { path: `mad-til-de-smaa_100.html`, redirectTo: `${environment.urls.products}/boernemenu` },
  { path: `selskabsmenuer_59.html`, redirectTo: `${environment.urls.products}/selskabsmenu` },
  { path: `receptionsmenuer_60.html`, redirectTo: `${environment.urls.products}/receptionsmenuer` },
  { path: `soedt---laekkert_61.html`, redirectTo: `${environment.urls.products}/desserter` },
  { path: `drikkevarer_70.html`, redirectTo: `${environment.urls.products}/drikkevarer` },
  { path: `gavekurve_108.html`, redirectTo: `${environment.urls.products}/Gavekurv` },
  { path: `fandankos-paaskefrokost_57.html`, redirectTo: `${environment.urls.products}/paasketapas-3492` },
  { path: `unika-oste-tapas_93.html`, redirectTo: `${environment.urls.products}/Osttapas-2744` },
  { path: `alt-godt-fra-havet-tapas_105.html`, redirectTo: `${environment.urls.products}/FiskTapas-2742` },
  { path: `tapas2go_53.html`, redirectTo: `${environment.urls.products}/Tapas-2842` },
  { path: `kaempe-muffin_61r173.html`, redirectTo: `${environment.urls.products}/ChokoladeCroissant-2861` },
  { path: `skinke---ost---deluxe_50r36.html`, redirectTo: `${environment.urls.products}/SandwichSkinkeOst-2822` },
  { path: `laks-med-smag_50r42.html`, redirectTo: `${environment.urls.products}/LaksSandwich-2824` },
  {
    path: `fandankos-flaeskestegssandwich---lun_50r209.html`,
    redirectTo: `${environment.urls.products}/Flaeskesteg_sandwich-2827`,
  },
  { path: `lasagne_52r430.html`, redirectTo: `${environment.urls.products}/Lasagne-2848` },
  { path: `pulled-pork-(lun)_50r475.html`, redirectTo: `${environment.urls.products}/PulledPork-2816` },
  { path: `drikkevarer_70.html`, redirectTo: `${environment.urls.products}/drikkevarer` },
  { path: `gourmetpizza_52r429.html`, redirectTo: `${environment.urls.products}/Gourmetpizza-2847` },
  { path: `pastrami_50r37.html`, redirectTo: `${environment.urls.products}/PastramiSandwich-2823` },
  { path: `vegetar/vegansk-sandwich_50r292.html`, redirectTo: `${environment.urls.products}/Sandwich_vegetar_vegansk-2825` },
  { path: `dessert-tapas-_61r52.html`, redirectTo: `${environment.urls.products}/Dessert%20_Tapas-2846` },
  { path: `hjemmelavet-pesto_53r240.html`, redirectTo: `${environment.urls.products}/FANDANKOs%20Pesto-2898` },
  { path: `gavekurve_108.html`, redirectTo: `${environment.urls.products}/Gavekurv` },
  { path: `selskabsmenuer_59.html`, redirectTo: `${environment.urls.products}/selskabsmenu` },
  { path: `lufttoerret-skinke_50r38.html`, redirectTo: `${environment.urls.products}/SandwichSkinke-2818` },
  { path: `pappardelle-med-kylling-og-svampe_52r432.html`, redirectTo: `${environment.urls.products}/Pappardelle-2852` },
  { path: `gratineret-foccacia-(lun)_50r40.html`, redirectTo: `${environment.urls.products}/GratineretFoccacia-2819` },
  { path: `fandankos-kreative_50r55.html`, redirectTo: `${environment.urls.products}/KreativSandwich-2817` },
  {
    path: `troeffel-mac---cheese-med-crispy-kylling-i-panko_52r436.html`,
    redirectTo: `${environment.urls.products}/Mac_and_cheese-2849`,
  },
  {
    path: `butter-chicken-med-naanbroed-og-couscous_52r435.html`,
    redirectTo: `${environment.urls.products}/Butter_Chicken-2851`,
  },
  { path: `fandankos-favorit_50r391.html`, redirectTo: `${environment.urls.products}/SandwichFavorit-2731` },
  { path: `fandankos-egen-is_61r50.html`, redirectTo: `${environment.urls.products}/Chokoladeis-2875` },
  { path: `brunch2go_49r10.html`, redirectTo: `${environment.urls.products}/Brunch-2729` },
  { path: `skoenne-gourmetkager_61r388.html`, redirectTo: `${environment.urls.products}/GourmetKager-2872` },
  { path: `hjemmelavet-aioli_53r239.html`, redirectTo: `${environment.urls.products}/BasilikumAioli-2897` },
  {
    path: `chili-con-carne-a-la-heston-blumenthal_52r510.html`,
    redirectTo: `${environment.urls.products}/Chili%20Con%20Carne-2853`,
  },
  { path: `philly-cheese-a-la-fandanko---lun_50r291.html`, redirectTo: `${environment.urls.products}/PhillyCheese-2826` },
  { path: `sandwich-buffet_50r113.html`, redirectTo: `${environment.urls.products}/Sandwich_Buffet-2828` },
  { path: `lufttoerret-skinke_53r38.html`, redirectTo: `${environment.urls.products}/SandwichSkinke-2818` },
  { path: `coca-cola-025_70r145.html`, redirectTo: `${environment.urls.products}/CocaCola25-2904` },
  { path: `oekologisk-saft_53r149.html`, redirectTo: `${environment.urls.products}/Hyldeblomstsaft-2905` },
  { path: `coca-cola-05_70r146.html`, redirectTo: `${environment.urls.products}/CocaCola50cl-2906` },
  { path: `antipasto-a-la-fandanko_51r45.html`, redirectTo: `${environment.urls.products}/Antipasto-2845` },
  { path: `fandanko-kildevand-05_53r152.html`, redirectTo: `${environment.urls.products}/Kildevand-2908` },
  { path: `fandankos-valg---salat_51r44.html`, redirectTo: `${environment.urls.products}/salat` },
  { path: `fandankos-store-broed_51r385.html`, redirectTo: `${environment.urls.products}/broed` },
  { path: `receptionsmenu-nr.-1_60r598.html`, redirectTo: `${environment.urls.products}/Receptionsmenu1-2857` },
  { path: `glutenfri-broed_51r315.html`, redirectTo: `${environment.urls.products}/Glutenfrit_broed-2909` },
  { path: `luksus-receptionsmenu_60r600.html`, redirectTo: `${environment.urls.products}/LuksusReceptionsmenu-2859` },
  { path: `receptionsmenu-nr.-2_60r599.html`, redirectTo: `${environment.urls.products}/Receptionsmenu2-2858` },
  { path: `cola-zero-05_53r150.html`, redirectTo: `${environment.urls.products}/CocaColaZero-2910` },
  {
    path: `sacred-hill-sauvignon-blanc-reserve-marlborough_70r413.html`,
    redirectTo: `${environment.urls.products}/Sacred_Hill_Sauvignon_Blanc-2911`,
  },
  { path: `les-glaneuses-rose_70r414.html`, redirectTo: `${environment.urls.products}/LesGlaneusesRosé-2913` },
  { path: `hjemmelavet-mojito-iscreme_53r256.html`, redirectTo: `${environment.urls.products}/Mojitois-2886` },
  { path: `fandanko-kildevand-05_53r152.html`, redirectTo: `${environment.urls.products}/Kildevand-2908` },
  { path: `let---laekkert_51.html`, redirectTo: `${environment.urls.products}/tapas` },
  { path: `nytaarsmenu-2021_124.html`, redirectTo: `${environment.urls.products}/nytaarsmenu` },
  { path: `jule-tapas-2021_56.html`, redirectTo: `${environment.urls.products}/jul` },
  { path: `studentermenu-fandanko_85.html`, redirectTo: `${environment.urls.products}/studentermenu` },
  { path: `bestilling_16.html`, redirectTo: `/kurv` },
];
